import useProperty from '@/hooks/api/useProperty';

export const useOrderId = () =>
    useProperty('Order', 'getId', { boundEvents: ['updateId'] });

export const useOrderCustomForSlotHtml = slot =>
    useProperty('Order', 'getCustomHtmlForSlot', {
        getArg: slot,
        boundEvents: ['updateCustomHtmlSlot'],
    });

export const useOrderAddress = () =>
    useProperty('Order', 'getAddress', { boundEvents: ['updateAddress'] });

export const useOrderAvailableMethods = () =>
    useProperty('Order', 'getAvailableMethods', {
        boundEvents: ['updateAvailableMethods'],
    });

export const useOrderAvailableMenus = () =>
    useProperty('Order', 'getAvailableMenus', {
        boundEvents: ['updateAvailableMenus'],
        initialState: [],
    });

export const useOrderMenu = () =>
    useProperty('Order', 'getMenu', {
        boundEvents: ['updateMenu'],
    });

export const useOrderAvailableTimes = date =>
    useProperty('Order', 'getAvailableTimes', {
        getArg: date,
        boundEvents: ['updateAvailableTimes'],
        initialState: [],
    });

export const useOrderAvailableDates = () =>
    useProperty('Order', 'getAvailableDates', {
        boundEvents: ['updateAvailableDates'],
        initialState: [],
    });

export const useOrderIsSyncingTimeSlots = () =>
    useProperty('Order', 'isSyncingTimeSlots', {
        boundEvents: ['updateTimeSlotsIsSyncing'],
        initialState: false,
    });

export const useOrderCustomer = () =>
    useProperty('Order', 'getCustomer', { boundEvents: ['updateCustomer'] });

export const useOrderExpectedAt = () =>
    useProperty('Order', 'getExpectedAt', {
        boundEvents: ['updateExpectedAt'],
    });

export const useOrderLocation = () =>
    useProperty('Order', 'getLocation', { boundEvents: ['updateLocation'] });

export const useOrderMethod = () =>
    useProperty('Order', 'getMethod', { boundEvents: ['updateMethod'] });

export const useOrderTableId = () =>
    useProperty('Order', 'getTableId', { boundEvents: ['updateTableId'] });

export const useOrderProductsQuantity = () =>
    useProperty('Order', 'getProductsQuantity', {
        boundEvents: ['updateProductsQuantity'],
    });

export const useOrderExpectedInString = () =>
    useProperty('Order', 'getExpectedInString', {
        boundEvents: ['updateExpectedInString'],
    });

export const useOrderIsAuthorisedForTesting = () =>
    useProperty('Order', 'isAuthorisedForTesting', {
        boundEvents: ['updateAuthorisedForTesting'],
        initialState: false,
    });

export const useOrderIsTest = () =>
    useProperty('Order', 'isTest', {
        boundEvents: ['updateIsTest'],
        initialState: false,
    });

export const useOrderIsConfirmable = () =>
    useProperty('Order', 'isConfirmable', {
        boundEvents: ['updateIsConfirmable'],
        initialState: false,
    });

export const useOrderIsSyncing = () =>
    useProperty('Order', 'isSyncing', {
        boundEvents: ['updateIsSyncing'],
        initialState: false,
    });

export const useOrderProductSuggestions = () =>
    useProperty('Order', 'getProductSuggestions', {
        boundEvents: ['updateProductSuggestions'],
        initialState: [],
    });

export const useOrderPopularItems = () =>
    useProperty('Order', 'getPopularItems', {
        boundEvents: ['updatePopularItems'],
        initialState: [],
    });

// TODO: Figure out how to design a hooks API
// These aren't hooks, but it seems reasonable that React components
// should have a single important to interface with an order.
// Perhaps the `use*` hooks should be refactored to return both a getter and
// a setter?
export const setOrderMenu = Mobi2Go.Order.setMenu;
export const setOrderIsTest = Mobi2Go.Order.setIsTest;
export const setOrderExpectedAt = Mobi2Go.Order.setExpectedAt;
export const setOrderTableId = Mobi2Go.Order.setTableId;
export const isOrderExpectedToday = Mobi2Go.Order.isExpectedToday;
export const isOrderExpectedTomorrow = Mobi2Go.Order.isExpectedTomorrow;
export const getOrderAvailableTimes = Mobi2Go.Order.getAvailableTimes;
export const sendOrderReceiptToEmailAddress =
    Mobi2Go.Order.sendReceiptToEmailAddress;
export const orderLog = Mobi2Go.Order.log;
